import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Invitation from './Invitation';
import AdminPanel from './AdminPanel';

function App() {
  return (
    <Routes>
      {/* Ruta 1: Home (Invitación Genérica) */}
      <Route path="/" element={<Invitation />} />
      
      {/* Ruta 2: Invitación Personalizada (ej: midominio.com/invitacion/familia-otto) */}
      <Route path="/invitacion/:id" element={<Invitation />} />
      
      {/* Ruta 3: Panel de Admin */}
      <Route path="/admin" element={<AdminPanel />} />
      
      {/* Ruta 4: Cualquier otra cosa redirige al home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;